(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-products-ajax"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-collection-list-section]').forEach((section) => {
    const grid = section.querySelector('[data-collection-list-grid]');
    const region = section.querySelector('[data-collection-products-region]');
    const container = section.querySelector('[data-collection-products-container]');
    let items = Array.from(section.querySelectorAll('[data-menu-item]'));
    let triggers = Array.from(section.querySelectorAll('.collection-card-wrapper'));

    if (!grid || !region || !container || !items.length || !triggers.length) return;

    function hideProducts() {
      region.hidden = true;
      container.innerHTML = '';
      triggers.forEach((btn) => {
        btn.setAttribute('aria-expanded', 'false');
      });
    }

    function renderThirdLevel(children) {
      if (!children || !children.length) {
        container.innerHTML = '<div class="collection-products__empty">No items</div>';
        region.hidden = false;
        return;
      }

      const html =
        '<div class="collection-products__grid">' +
        children
          .map(
            (child) =>
              '<div class="collection-products__product">' +
              '<a href="' +
              child.url +
              '">' +
              '<div class="collection-products__title">' +
              child.title +
              '</div>' +
              '</a>' +
              '</div>',
          )
          .join('') +
        '</div>';

      if (document.startViewTransition) {
        document.startViewTransition(() => {
          container.innerHTML = html;
          region.hidden = false;
        });
      } else {
        container.innerHTML = html;
        region.hidden = false;
      }
    }

    function findThirdLevelByTitle(title) {
      if (!window.menuRoots || !Array.isArray(window.menuRoots)) return [];
      for (const root of window.menuRoots) {
        if (!root.children) continue;
        for (const child of root.children) {
          if (child.title === title) {
            return child.children || [];
          }
        }
      }
      return [];
    }

    // URL 过滤逻辑：继续使用 collection_handles 参数名，但现在按 data-menu-title 过滤
    (function filterByUrl() {
      try {
        const params = new URLSearchParams(window.location.search);
         console.log(params,"2")
        const raw = params.get('collection_handles');
       
        if (!raw) return;

        const allowed = raw
          .split(',')
          .map((t) => decodeURIComponent(t).trim().toLowerCase())
          .filter(Boolean);

        if (!allowed.length) return;

        items.forEach((item) => {
          const title = (item.dataset.menuTitle || '').toLowerCase();
          if (!allowed.includes(title)) {
            item.remove();
          }
        });

        items = Array.from(section.querySelectorAll('[data-menu-item]'));
        triggers = Array.from(section.querySelectorAll('.collection-card-wrapper'));

        if (!items.length || !triggers.length) {
          hideProducts();
        }
      } catch (e) {
        console.error('URL filter error:', e);
      }
    })();

    hideProducts();

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const title = trigger.dataset.menuTitle;
        const expanded = trigger.getAttribute('aria-expanded') === 'true';

        if (expanded) {
          hideProducts();
          return;
        }

        triggers.forEach((btn) => btn.setAttribute('aria-expanded', 'false'));
        trigger.setAttribute('aria-expanded', 'true');

        const thirdLevel = findThirdLevelByTitle(title);
        renderThirdLevel(thirdLevel);
      });
    });

    document.addEventListener('click', (event) => {
      if (!section.contains(event.target)) {
        hideProducts();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
